'use client'

import { memo } from 'react'
import clsx from 'clsx'

import styles from './DateItem.module.scss'

export type DateItemProps = {
  date: {
    date: string
    dayOfWeek: string
    shortDate: string
  }
  isActive: boolean
  hasSelection?: boolean
  onClick: () => void
}

export const DateItem = memo(
  ({ date, isActive, hasSelection, onClick }: DateItemProps) => (
    <button
      className={clsx(styles.wrapper, {
        [styles.active]: isActive,
        [styles.hasSelection]: hasSelection
      })}
      onClick={onClick}
    >
      <p className={styles.title}>{date.shortDate}</p>
      <p className={styles.text}>{date.dayOfWeek}</p>
    </button>
  )
)

DateItem.displayName = 'DateItem'
